export const getHipticFeedback = (
  style: "light" | "medium" | "heavy" | "rigid" | "soft" = "soft"
) => {
  if (window.Telegram?.WebApp?.HapticFeedback) {
    window.Telegram.WebApp.HapticFeedback.impactOccurred(style);
  }
};
